import { trackPromise } from 'react-promise-tracker';
import api from './api';
import moment from "moment";
import formatDommus from '../helpers/format';

const setLocalState = (name, value) => {
  localStorage.setItem('@DommusCA-' + name, JSON.stringify(value));
};
const getLocalState = name => {
  return JSON.parse(localStorage.getItem('@DommusCA-' + name));
};

function checkPermissaoExists(obj, level, ...rest) {
  if (obj === undefined) return false
  if (rest.length === 0 && obj.hasOwnProperty(level)) return true
  return checkPermissaoExists(obj[level], ...rest)
}

const prepararFiltros = (filtrosEntrada) => {
  let dataAtual = moment().format("YYYY-MM-DD");
  let filtros = filtrosEntrada;
  if (!(filtrosEntrada && filtrosEntrada.data_inicio)) {
    filtros = Object.assign({}, { data_inicio: dataAtual, data_fim: dataAtual }, filtrosEntrada || {})
  }
  let filtrosQueRealmenteVai = Object.assign({}, filtros);
  if (filtros && filtros.data_inicio) {
    let dataAux = ((filtros.data_inicio instanceof Date) && filtros.data_inicio) || moment(filtros.data_inicio).format("YYYY-MM-DD");
    filtrosQueRealmenteVai.data_inicio = dataAux;
  }
  if (filtros && filtros.data_fim) {
    let dataAuxFim = ((filtros.data_fim instanceof Date) && filtros.data_fim) || moment(filtros.data_fim).format("YYYY-MM-DD");
    filtrosQueRealmenteVai.data_fim = dataAuxFim;
  }
  if(filtrosQueRealmenteVai.data_criacao_inicio && filtrosQueRealmenteVai.data_criacao_fim) {
    delete filtrosQueRealmenteVai.data_fim
    delete filtrosQueRealmenteVai.data_inicio
  }
  return filtrosQueRealmenteVai;
}

const caAPI = {
  setLocalState,
  getLocalState,
  ID_MODULO_DESK: 9,

  formatServerError: (err) => {
    let message = 'Houve um problema ao processar sua solicitação.';
    let reference_id = null;
    if (err && err.response) {
      let data = err.response.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch(e) { /* ignore */ }
      }
      if (data && data.error) {
        message = data.error.message || message;
        reference_id = data.error.reference_id || data.reference_id || null;
      } else if (data && data.message) {
        message = data.message;
      }
      if (!reference_id && err.response.headers) {
        reference_id = err.response.headers['x-reference-id'] || err.response.headers['reference_id'] || null;
      }
    } else if (err && err.message) {
      message = err.message;
    }
    return { message, reference_id };
  },

  logout: async () => {
    if(getLocalState('token')) {
      await caAPI.perfil.atualizar({ online: false }, getLocalState('idUsuario'), getLocalState('token'))
    }
    localStorage.removeItem('@DommusCA-token');
    localStorage.removeItem('@DommusCA-telas');
    localStorage.removeItem('@DommusCA-idUsuario');
    localStorage.removeItem('@DommusCA-tipoUsuario');
    localStorage.removeItem('@DommusCA-nomeUsuario');
    localStorage.removeItem('@DommusCA-permissoes');
    localStorage.removeItem('@DommusCA-contatosVeTudo');
    localStorage.removeItem('@DommusCA-visualizaNaoAtendidos');
    localStorage.removeItem('@DommusCA-limpaBacia');
    localStorage.removeItem('@DommusCA-tempoLimiteVoipSegundos');

    if (window.location.pathname !== '/login') {
      window.location = process.env.REACT_APP_GU_FRONT + '/modulo/logout';
    }
  },

  setLoginInfo: async data => {
    setLocalState('token', data.access_token);
    setLocalState('nomeUsuario', data.nome_usuario);
    setLocalState('idUsuario', data.id_usuario);
    setLocalState('idCliente', data.id_cliente);
    setLocalState('tipoUsuario', data.id_usuario_tipo);
    setLocalState('permissoes', data.permissoes);
    setLocalState('contatosVeTudo', data.atendimentos_contato_origem);
    setLocalState('visualizaNaoAtendidos', data.visualiza_atendimentos_nao_atendidos);
    setLocalState('limpaBacia', data.limpa_bacia);
    setLocalState('habilitaMarcadoresAposFinalizacao', data.habilitar_marcadores_apos_finalizacao);
    setLocalState('tempoLimiteVoipSegundos', data.tempo_limite_voip_segundos);
    setLocalState('usuariosPermitidosVisualizar', data.usuariosPermitidosVisualizar)

    await caAPI.perfil.atualizar({ online: true }, data.id_usuario, data.access_token)     
  },

  validaToken: token => {
    return api.post('gu-api/valida-token', {
      token
    });
  },

  barraTopo: function() {
    return api.get('/estatistica/index');
  },
  meio_comunicacao: {
    list: () => {
      return api.get('/meio-comunicacao')
    },
    getTemplate: (id_meio_comunicacao) => {
      return api.get(`/meio-comunicacao/templates/${id_meio_comunicacao}`)
    },
    getTemplatesAprovados: (slug_meio_comunicacao) => {
      return api.get(`/meio-comunicacao/templates/${slug_meio_comunicacao}-aprovados`)
    },
    getTemplatesAprovadosComOrigem: (slug_meio_comunicacao, origem) => {
      return api.get(`/meio-comunicacao/templates/${slug_meio_comunicacao}-aprovados/${origem}`)
    },
    buscarContatoOrigem: (slug_meio_comunicacao) => {
      return api.get(`/meio-comunicacao/contato/${slug_meio_comunicacao}`);
    },
    buscarModelosModulo:(idMeioComunicacao, idModulo) => {
      return api.get(`meio-comunicacao/${idMeioComunicacao}/modulo/${idModulo}/modelo`);
    },
    buscarTagsModelo:(idMeioComunicacao, idModulo, idModelo) => {
      return api.get(`meio-comunicacao/${idMeioComunicacao}/modulo/${idModulo}/modelo/${idModelo}/tags`);
    },buscarListaModelosPorTipo:(tipoModelo, idModulo) => {
      return api.get(`modulo/${idModulo}/modelo/tipo/${tipoModelo}`);
    }
  },
  contato_origem: {
    list: () => {
      return api.get(`/contato-origem`)
    },
    buscarContatoOrigem: (idContatoOrigem) => {
      return api.get(`/contato-origem/${idContatoOrigem}`)
    },
    update: (idContatoOrigem, payload) => {
      return api.put(`/contato-origem/${idContatoOrigem}`, {contato_origem: payload})
    },
    atualizarAgenteIa: (idContatoOrigem, idAgenteIa) => {
      return api.patch(`/contato-origem/${idContatoOrigem}/agente-ia`, { id_agente_ia: idAgenteIa })
    }
  },
  agenteIa: {
    listarModelos: () => {
      return api.get('/agente-ia/modelos')
    },
    listarModelosIa: (slug) => {
      return api.get(`/agente-ia/modelos/${slug}/modelos-ia`)
    },
    listarUsuariosAtorElegiveis: (slug, idAgenteIa = null) => {
      return api.get('/agente-ia/usuarios-ator', { params: { modelo: slug, id_agente_ia: idAgenteIa } })
    },
    listarCapacidadesModelo: (slug) => {
      return api.get(`/agente-ia/modelos/${slug}/capacidades`)
    },
    list: (payload = null) => {
      return api.get('/agente-ia', { params: payload })
    },
    buscarPorId: (idAgenteIa) => {
      return api.get(`/agente-ia/${idAgenteIa}`)
    },
    create: (dados) => {
      return api.post('/agente-ia', dados)
    },
    update: (idAgenteIa, dados) => {
      return api.put(`/agente-ia/${idAgenteIa}`, dados)
    },
    alterarEstado: (idAgenteIa, ativo) => {
      return api.patch(`/agente-ia/${idAgenteIa}/ativo`, { ativo })
    },
    rotacionarChave: (idAgenteIa, chaveApi, idChaveApi) => {
      return api.post(`/agente-ia/${idAgenteIa}/rotacionar-chave`, {
        chave_api: chaveApi,
        id_chave_api: idChaveApi
      })
    },
    listarCapacidades: (idAgenteIa) => {
      return api.get(`/agente-ia/${idAgenteIa}/capacidades`)
    },
    associarCapacidade: (idAgenteIa, slugCapacidade) => {
      return api.post(`/agente-ia/${idAgenteIa}/capacidades`, { slug_capacidade: slugCapacidade })
    },
    desassociarCapacidade: (idAgenteIa, slugCapacidade) => {
      return api.delete(`/agente-ia/${idAgenteIa}/capacidades/${slugCapacidade}`)
    },
    listarBasesConhecimento: (idAgenteIa) => {
      return api.get(`/agente-ia/${idAgenteIa}/bases-conhecimento`)
    },
    associarBaseConhecimento: (idAgenteIa, idBaseConhecimento) => {
      return api.post(`/agente-ia/${idAgenteIa}/bases-conhecimento`, {
        id_base_conhecimento: idBaseConhecimento
      })
    },
    atualizarVinculoBaseConhecimento: (idAgenteIa, idBaseConhecimento, dados) => {
      return api.patch(`/agente-ia/${idAgenteIa}/bases-conhecimento/${idBaseConhecimento}`, dados)
    },
    reordenarBasesConhecimento: (idAgenteIa, idsBases) => {
      return api.put(`/agente-ia/${idAgenteIa}/bases-conhecimento/ordem`, {
        ids_base_conhecimento: idsBases
      })
    },
    desassociarBaseConhecimento: (idAgenteIa, idBaseConhecimento) => {
      return api.delete(`/agente-ia/${idAgenteIa}/bases-conhecimento/${idBaseConhecimento}`)
    },
    listarContatosOrigem: (idAgenteIa) => {
      return api.get(`/agente-ia/${idAgenteIa}/contatos-origem`)
    },
    listarBasesElegiveis: () => {
      return api.get('/agente-ia/bases-conhecimento')
    },
    listarEtapasFluxoModelo: (slug) => {
      return api.get(`/agente-ia/modelos/${slug}/etapas-fluxo`)
    },
    listarFluxoAtendimento: (idAgenteIa) => {
      return api.get(`/agente-ia/${idAgenteIa}/fluxo-atendimento`)
    },
    salvarFluxoAtendimento: (idAgenteIa, etapas) => {
      return api.put(`/agente-ia/${idAgenteIa}/fluxo-atendimento`, { etapas })
    },
  },
  baseConhecimento: {
    list: (payload = null) => api.get('/base-conhecimento', { params: payload }),
    buscarPorId: (idBaseConhecimento) => api.get(`/base-conhecimento/${idBaseConhecimento}`),
    create: (dados) => api.post('/base-conhecimento', dados),
    update: (idBaseConhecimento, dados) => api.put(`/base-conhecimento/${idBaseConhecimento}`, dados),
    delete: (idBaseConhecimento) => api.delete(`/base-conhecimento/${idBaseConhecimento}`),
    listarArquivos: (idBaseConhecimento, payload = null) => api.get(
      `/base-conhecimento/${idBaseConhecimento}/arquivo`,
      { params: payload }
    ),
    enviarArquivos: (idBaseConhecimento, dados) => api.post(
      `/base-conhecimento/${idBaseConhecimento}/arquivo`,
      dados,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    ),
    removerArquivo: (idBaseConhecimento, idArquivo) => api.delete(
      `/base-conhecimento/${idBaseConhecimento}/arquivo/${idArquivo}`
    ),
    marcarAprendizado: (idBaseConhecimento, dados) => api.patch(
      `/base-conhecimento/${idBaseConhecimento}/aprendizado`,
      dados
    ),
    listarExperiencias: (idBaseConhecimento, payload = null) => api.get(
      `/base-conhecimento/${idBaseConhecimento}/experiencia-aprendizado`,
      { params: payload }
    ),
  },
  experienciaAprendizado: {
    previa: (dados) => api.post('/experiencia-aprendizado/previa', dados),
    store: (dados) => api.post('/experiencia-aprendizado', dados),
    tentarNovamente: (id) => api.post(`/experiencia-aprendizado/${id}/tentar-novamente`),
    destroy: (id) => api.delete(`/experiencia-aprendizado/${id}`, { data: { confirmar: true } }),
  },
  configuracaoOpenAi: {
    buscar: () => api.get('/agente-ia/configuracao-openai'),
    atualizar: (dados) => api.patch('/agente-ia/configuracao-openai', dados),
  },
  relatorios: {
    list: () =>{
      return api.get('/relatorios')
    }
  },
  situacao: {
    list: () => {
      return api.get('/situacao')
    }
  },
  tipo_conteudo: {
    list: () => {
      return api.get('/tipo-conteudo')
    }
  },
  tipo_atendimento: {
    list: () => {
      return api.get('/tipo-atendimento')
    }
  },
  tipo_historico_atendimento: {
    list: () => {
      return api.get('/tipo-historico-atendimento')
    }
  },
  template: {
    list: (payload=null) => {
      return api.get(`/template`, {params:payload})
    },
    buscaPorId: (id_template) => {
      return api.get(`/template/${id_template}`)
    },
    create: (template, id_atendimento) => {
      if (id_atendimento) {
        return api.put(`/template/${id_atendimento}`, template)
      } else {
        return api.post(`/template`, template)
      }

    },
    atualizar: (template) => {
      return api.put(`/template/${template.id}`, {
        nome: template.nome,
        tipo_atendimento: template.tipo_atendimento,
        meio_comunicacao: template.meio_comunicacao,
        mensagem: template.mensagem
      })
    },
    deletar: (id_template) => {
      return api.delete(`/template/${id_template}`)
    },
    buscarTiposAnexos: () => {
      return api.get("/template/buscarTiposAnexos");
    },
    uploadBase64: (arquivo, nomeArquivo=null) => {
      return api.post('/template/arquivo', { arquivo, nomeArquivo })
    },
    validarSidTemplate: (idTemplate, templateSid, accountSid = null) => api.get(
      `/template/${idTemplate}/sid/${templateSid}`,
      {
        params: {
          accountSid
        }  
      }
    ),
    enviarAprovacaoWhatsapp: (idTemplate, payload) => {
      return api.post(`/template/${idTemplate}/aprovacao-whatsapp`, payload)
    },
  },

  labels: {
    list: () => {
      return api.get(`/label`)
    },
    update: (id, value) => {
      return api.put(`/label/${id}`, {
        label: value
      })
    },
  },
  tags:{
    list: () => {
      return api.get('/tag');
    },
    listTagsAtendimentoDistintos: () =>{
      return api.get('/tag-atendimento/distintos')
    },
    adicionarTagAtendimento: (idAtendimento, payload) =>{
      return api.post(`/tag-atendimento/atendimento/${idAtendimento}`, payload)
    },
    create: (value) => {
      let data = {
        nome: value
      }
      return api.post('/tag', data);
    },
    update: (value, idTag) => {
      let data = {
        nome: value
      }
      return api.put(`/tag/${idTag}`, data);
    },
    delete: (idTag) => {
      return api.delete(`/tag/${idTag}`);
    },
    removerTagsAtendimento: (tags)=>{
      return api.put('/tag-atendimento/remove-tags-atendimentos', tags);
    }
  },
  atendimento: {
    chamar: (idAtendimento) => {
      return api.get(`/atendimento/voip/chamar/${idAtendimento}`);
    },
    list: (date = null) => {
      return api.get('/atendimento?date=' + date);
    },
    getMessages: (id, page = 1) => {
      return api.get(`/atendimento/${id}/mensagens/${page}`);
    },
    find: id => {
      return api.get(`/atendimento/${id}`);
    },
    findWithoutReading: id => {
      return api.get(`/atendimento/sem-ler/${id}`);
    },
    create: (data, idAtendimento) => {
      if (!idAtendimento) {
        return api.post(`/atendimento`, data);
      } else {
        return api.put(`/atendimento/${idAtendimento}/atender`, data);
      }
    },
    atender: (data, idAtendimento) => {
      return api.put(`/atendimento/${idAtendimento}/atender`, data);
    },
    update: (data, idAtendimento) => {
      return api.put(`/atendimento/${idAtendimento}`, data);
    },
    acaoEmMassa: (acao, payload) => {
      return api.put(`/atendimento/acao-em-massa/${acao}`, payload);
    },
    buscarOutrosAtendimento: (idAtendimento) => {
      return api.get(`/atendimento/${idAtendimento}/outros-atendimentos`);
    },
    buscarOutrosAtendimentosPorProcesso: (idProcesso) => {
      return api.get(`/atendimento/processo/${idProcesso}/atendimentos`);
    },
    buscarChamadosVinculados: (idAtendimento) => {
      return api.get(`/atendimento/${idAtendimento}/chamados/vinculados`);
    },
    buscarChamadosVinculo: (idAtendimento, idProcesso) => {
      return api.get(`/atendimento/${idAtendimento}/processo/${idProcesso}/chamado/vinculo`)
    },
    desvincularChamado: (idAtendimento, idChamado) => {
      return api.delete(`/atendimento/${idAtendimento}/chamado/${idChamado}/vinculo`);
    },
    buscarItensEnviados: (filtros) => {
      return api.get(`/atendimento/itens-enviados`, {params: {filtros}})
    },
    enviarRespostaAutomaticaTemplate: (payload) => {
      return api.post(`/atendimento/envio-resposta-automatica`, payload);
    },
    vincularChamado: (idAtendimento, idChamado) => {
      let payload = {
        id_atendimento: idAtendimento,
        id_ticket: idChamado
      };
      return api.post(`/atendimento/chamado/vinculo`, payload);
    },
    exportarAtendimentosPdf: (atendimentosSelecionados, selecionarTodos, filtros) =>{
      let payload = {
        atendimentos_selecionados: atendimentosSelecionados,
        selecionar_todos: selecionarTodos,
        filtros: filtros
      }
      return api.post(`/atendimento/exportacao-pdf`, payload, { responseType: 'blob' });
    },
    arquivado: {
      list: (page = 1, tamanho = 10, filtros = {}) => {
        return api.get(`/atendimento/arquivados`, {
          params: {
            pagina: page,
            limite: tamanho,
            filtros: encodeURIComponent(JSON.stringify(filtros))
          }
        })
      },
      total: () => {
        return api.get(`/atendimento/arquivados/total`)
      },
      desarquivar: id => {
        return api.put(`/atendimento/arquivados/recuperar/${id}`);
      },
      historico: (id) => {
        return api.get(`/atendimento/${id}/historico`)
      }
    },
    anotacao: {
      list: (id_atendimento) => {
        return api.get(`/atendimento/anotacao/${id_atendimento}`)
      },
      enviar: (id_atendimento, conteudo) => {
        return api.post(`/atendimento/anotacao/${id_atendimento}`, {
          anotacao: conteudo
        })
      },
      atualizar: (id_atendimento, id_anotacao, conteudo) => {
        return api.put(`/atendimento/anotacao/${id_atendimento}/${id_anotacao}`, {
          "anotacao": conteudo
        })
      },
      deletar: (id_atendimento, id_anotacao) => {
        return api.delete(`/atendimento/anotacao/${id_atendimento}/${id_anotacao}`)
      }

    },
    sms: {
      enviar: (id_atendimento, data) => {
        return api.post(`/atendimento/sms/${id_atendimento}`, data);
      },
      buscar: contato => {
        return api.post('/atendimento/sms/listar-por-numero', {
          "contato_destino": contato
        })
      },
      dispararTemplate: (idTemplate, contatos, separador = ";") =>{
        return api.post(`/atendimento/sms/enviar-massa/${idTemplate}`, {
          "base64_destinatarios": btoa(contatos),
          "separador": separador
        })
      }
    },
    email: {
      enviar: (data, formData=false) => {
        const config = (formData && { 
          headers: {
            'Content-Type': 'multipart/form-data'
          } 
        }) || {}
        return api.post('/atendimento/email', data, config);
      },
      buscar: id => {
        return api.get(`/atendimento/${id}`)
      },
      getAnexo: file => {
        return api.get(`/atendimento/email/anexo/${file}`);
      },
      getAssinatura: () => {
        return api.get('/usuario/assinatura');
      },
      buscarUltimosAnexosPorAtendimento: (idAtendimento) => api.get(`/atendimento/${idAtendimento}/email/ultimos-anexos`)
    },
    chatbot: {
      enviar: (data) => {
        return api.post('/send/blip', data);
      }
    },
    reclameAqui: {
      enviar: (data) => {
        return api.post('/ra/send', data)
      }
    },
    facebookMessenger: {
      send: (data) => {
        return api.post('/facebook/send', data)
      },
      sendImage: (data) => {
        return api.post('/facebook/send/image', data)
      }
    },
    whatsapp: {
      atualizarMensagensMes: (idAtendimento) => {
        return api.get(`/atendimento/whatsapp/atualizar-mensagens-mes/${idAtendimento}`);
      },iniciar: data => {
        return api.post('/atendimento/whatsapp/iniciar-atendimento', data);
      },
      enviar: data => {
        return api.post('/atendimento/whatsapp', data)
      },
      templates: () => {
        return api.get('/meio-comunicacao/templates/whatsapp')
      },
      templatesAprovados: () => {
        return api.get('/meio-comunicacao/templates/whatsapp-aprovados')
      },
      templatesAprovadosComOrigem: (origem) => {
        return api.get('/meio-comunicacao/templates/whatsapp-aprovados/' + origem)
      }
    },
    voip: {
      buscarGravacao:(callSid, id_atendimento=null)=> {
        return api.get(`/atendimento/voip/gravacao/${callSid}`, {params: {id_atendimento}});
      },
      iniciarChamada: (id_atendimento, call_sid)=> {
        return api.get(`/atendimento/voip/iniciar/${id_atendimento}/${call_sid}`);
      },
      novoIniciarChamada: (id_atendimento, call_sid)=> {
        return api.get(`/atendimento/voip/novo-iniciar/${id_atendimento}/${call_sid}`);
      },
      salvarDuracao: (id_atendimento, id_chamada, duracao) => {
        return api.post(`/atendimento/voip/ligacao/${id_atendimento}/${id_chamada}/duracao`, {
          duracao:duracao
        });
      },
      // dont use.

      listaNumerosCliente: () => {
        return api.get('/atendimento/voip/numeros-cliente');
      },
      chamarAgent: idAtendimento => api.get(`atendimento/voip/chamar-sem-atendente/${idAtendimento}`),
      encerrarConferencia: (idAtendimento) => api.delete(`atendimento/voip/${idAtendimento}`),
      // Comando idempotente que substitui o antigo GET /atendimento/{id}/reenviar-fila.
      // dados: { id_conteudo_atendimento, call_sid, numero_tentativa, motivo }
      redistribuir: (dados) => api.post('/atendimento/voip/redistribuir', dados)
    },
    transferenciaNaoAtendida: (id, atendenteOriginal, tipoHistorico = 13) => {
      return api.post(`/atendimento/${id}/transferencia-perdida`,{
        atendente_original: atendenteOriginal,
        tipo_historico: tipoHistorico
      });
    },
    processo: {
      buscaPorId: id_processo => {
        return api.get(`/atendimento/detalhes/getByProcesso/${id_processo}`);
      },
      buscarPorCodigoRelacionamento: codigoRelacionamento => {
        return api.get(`/atendimento/detalhes/getByCodigoRelacionamento/${codigoRelacionamento}`);
      },
      buscarPorInfo: info => {
        return api.post(`/atendimento/detalhes/buscar`, {
          search: info
        });
      },
      salvaProcesso: (id_atendimento, data) => {
        return api.put(`/atendimento/detalhes/alterar/${id_atendimento}`, data);
      },
      listarVinculados: (id_atendimento) => {
        return api.get(`/atendimento/${id_atendimento}/processo`);
      },
      vincular: (id_atendimento, processos) => {
        return api.post(`/atendimento/${id_atendimento}/processo`, { processos });
      },
      desvincular: (id_atendimento, id_processo) => {
        return api.delete(`/atendimento/${id_atendimento}/processo/${id_processo}`);
      },
      definirPrincipal: (id_atendimento, id_processo) => {
        return api.put(`/atendimento/${id_atendimento}/processo/${id_processo}/principal`);
      }
    },
    chamado: {
      buscarPorId: id_ticket => {
        return api.get(`/atendimento/detalhes/ticket/${id_ticket}`)
      }
    },
    opv: {
      buscaPorId: id_opv => {
        return api.get(`/atendimento/detalhes/getByOportunidade/${id_opv}`);
      }
    },
    lead: {
      enviaLead: (id_atendimento, campanha, empreendimento, data) => {
        return api.post(`/atendimento/lead/${id_atendimento}/${campanha}/${empreendimento}`, {
            data
        });
      }
    },
    atendentes: {
      listaAtendentes: () => {
        return api.get('/atendentes')
      },
      listaAtendentesTransferencia: () => {
        return api.get('/atendentes-transferencia')
      }
    },
    filtro: {
      filtrar: (filtros, page = 1) => {
        const filtrosQueRealmenteVai = prepararFiltros(filtros);
        return api.get(`/atendimento`, {
          params: {
            filtros: filtrosQueRealmenteVai,
            pagina: page,
          }
        })
      },
      total: (filtros) => {
        const filtrosQueRealmenteVai = prepararFiltros(filtros);
        return api.get(`/atendimento/total`, {
          params: {
            filtros: filtrosQueRealmenteVai
          }
        })
      },
      exportar: (filtros, exportar) => {
        const filtrosQueRealmenteVai = prepararFiltros(filtros);
        return api.get(`/atendimento/exportar`, {
          params: {
            filtros: filtrosQueRealmenteVai,
            exportar: true
          }
        })
      },
    },
    registroOutrosAtendimentos:{
      buscar: (data) => {
        return api.get(`/atendimento/registros-outros?contato_destino=${data?.contato_destino}&processo=${data?.processo}&oportunidade=${data?.oportunidade}&tamanho_pagina=${data?.tamanho_pagina}&page=${data?.page}`);
      },
    },
  },
  perfil:{
    buscarVistoUltimo:() => {
    return api.get("/perfil-usuario/visto-ultimo");
  },
    tempoOnline: (id, filtro) => {
    return api.get(`/perfil-usuario/tempo-online`, {params: {
      filtro: filtro,
      usuarios: id
    }})
  },
    atualizar: (dados, idUsuario=null, token=null) => api.put(`perfil-usuario/${idUsuario || getLocalState('idUsuario')}`, dados, token && { 
      headers: {
        Authorization: token
      }
    } || undefined)
  },

  loginGU: token => {
    return api.get(`/gu-api/login/${token}`);
  },
  getTokenCcd: function(contatoOrigem = null) {
    return api.post('/atendimento/voip/get-token', {
      contato_origem: contatoOrigem
    });
  },
  makeCall: function(number) {
    return api.post('/make-call', {
      number
    });
  },
  checkPermissaoExists,
  permissao: {
    pode: path => {
      const jsonPermissao = JSON.parse(getLocalState('permissoes'));
      const arrayPath = path.split('.');
      if (!checkPermissaoExists(jsonPermissao, [arrayPath[0]], [arrayPath[1]], [arrayPath[2]])) {
        return false
      }
      return jsonPermissao[arrayPath[0]][arrayPath[1]][arrayPath[2]];
    }
  },
  bacia:{
    buscar: () => {
      return api.get("/bacia-atendimento");
    },
    recuperar: () => {
      return api.get("/bacia-atendimento/recuperar-atendimento");
    },
    limpar: ()=>{
      return api.delete('/bacia-atendimento');
    },
  },
  modulo:{
    buscar: () => {
      return api.get("/modulo");
    },
  },
  historicoAtendimento:{
    total: (filtros = {}, filtrarAtual = true, filtrarSnapshot = true) => {
      return api.get("/historico-atendimento/total", {
        params: {
          filtros: filtros,
          filtrar_atual: filtrarAtual,
          filtrar_snapshot: filtrarSnapshot
        }
      })
    },
    index: (pagina = 1, limite = 20, filtros = {}, filtrarAtual = true, filtrarSnapshot = true) => {
      return api.get("/historico-atendimento", {
        params: {
          pagina: pagina,
          limite: limite,
          filtros : filtros,
          filtrar_atual: filtrarAtual,
          filtrar_snapshot: filtrarSnapshot
        }
      });
    },
    show:(id)=>{
      return api.get(`/historico-atendimento/${id}`);
    }
  },
  arquivoAtendimento: {
    buscar: (filtros) => {
      return trackPromise(api.get('/arquivo-atendimento', { params: filtros }))
    },
    salvar: (arquivos) => {
      return trackPromise(api.post('/arquivo-atendimento', arquivos))
    },
    excluir: (idArquivo) => {
      return trackPromise(api.delete(`/arquivo-atendimento/${idArquivo}`))
    },
    downloadArquivoPrivado: (url, downloadAudio = false) => {
      return (api.get('/arquivo-atendimento/arquivo-privado', {
        params: { url, downloadAudio },
        responseType: 'blob'
      }))
    }
  },
  buscarTokenAcessoModulo: (idModulo) =>{
    return trackPromise(api.get(`buscar-token-modulo-usuario/${caAPI.getLocalState('guToken')}/${idModulo}`))
  },
  configuracoes : {
    buscar: (chave) => {
      return api.get(`/config/chave/${chave}`);
    }
  },
  permissoes: {
    verificarDownloadAudio: () => {
      return api.get('/perfil-usuario/permissao-download-audio');
    }
  },
  whatsapp_sender: {
    registrar: (dados) => api.post('/sender-whatsapp/registrar', dados),
    verificarOtp: (dados) => api.post('/sender-whatsapp/verificar-otp', dados),
    diagnosticarConfiguracao: (idInquilino) => api.get('/sender-whatsapp/diagnosticar-configuracao', { params: { id_inquilino: idInquilino } }),
  }
};

export default caAPI;
